import React from 'react';

import InitialLogo from '../logos/InitialLogo';
import AnnualLogo from '../logos/AnnualLogo';
import LoginForm from './LoginForm';
import { Link } from 'react-router-dom';

export const LoginPage = () => {
  return (
    <div className="LoginPage">
      <div className="LoginPage__logos">
        <div className="LoginPage__logo">
          <InitialLogo />
        </div>
        <div className="LoginPage__logo">
          <AnnualLogo />
        </div>
      </div>
      <div className="LoginPage__form">
        <h2>Welcome!</h2>
        <p>Sign in to access license information.</p>
        <LoginForm />
        <div className="LoginPage__new_user_div">
          <h4><Link to='../purchase'> Create New User</Link></h4>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/login/LoginPage.js